import ScalarIconButton_vue_vue_type_script_setup_true_lang_default from "./ScalarIconButton.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconButton/ScalarIconButton.vue
var ScalarIconButton_default = ScalarIconButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconButton_default as default };

//# sourceMappingURL=ScalarIconButton.vue.js.map